import angular from 'angular';
import { SCROLL_OFFSET } from '../../../../constants';

// This directive scrolls to the first invalid form element found.
const ScrollToError = function() {
  return {
    link(scope, element) {
      if (!['FORM', 'NG-FORM'].includes(element.prop('tagName'))) {
        throw new Error(
          'Trying to attach scroll-to-error to an element other than a form.'
        );
      }

      element.on('submit', function() {
        const firstError = element[0].querySelector('.ng-invalid');

        if (firstError !== null) {
          window.scrollBy({
            top: firstError.getBoundingClientRect().top - SCROLL_OFFSET,
            left: 0,
            behavior: 'smooth',
          });

          // Focus on the error after the scroll animation is done,
          // otherwise Chrome will automatically scroll the focused field
          // into view (without smooth animation)
          let scrollTimeout = null;

          const scrollListener = () => {
            if (scrollTimeout) {
              clearTimeout(scrollTimeout);
            }

            scrollTimeout = window.setTimeout(() => {
              firstError.focus();
              window.removeEventListener('scroll', scrollListener);
            }, 150);
          };

          window.addEventListener('scroll', scrollListener);
        }
      });
    },
  };
};

export default angular
  .module('app.directives.scroll-to-error', [])
  .directive('scrollToError', ScrollToError);
